var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "knowledge-block-articles" }, [
    _c("div", { staticClass: "pt-3 pb-3 row justify-content-between" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("h2", [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5 text-md-right text-left" })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.customArticles, function(article) {
        return _c(
          "div",
          { key: article.id, staticClass: "article-container pb-4 col-lg-9" },
          [
            _c("div", { staticClass: "article-title-container mb-1" }, [
              article.type == "KNOWLEDGE"
                ? _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to:
                              "/" +
                              _vm.platformCategory +
                              "/articles/" +
                              article.id
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.redirectToArticle(article.name)
                            }
                          }
                        },
                        [_vm._v(_vm._s(article.name))]
                      )
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "a",
                      {
                        attrs: { href: article.url },
                        nativeOn: {
                          click: function($event) {
                            return _vm.redirectToArticle(article.name)
                          }
                        }
                      },
                      [_vm._v(_vm._s(article.name))]
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "article-description-container" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.showDescription(article)) }
              })
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-315dff42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315dff42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeBlockArticle.vue
// module id = null
// module chunks = 